/**
 * Auth brand chrome — SOVIQ AI wordmark + tagline (existing v4 brand-tt pattern).
 * No new logo assets: text wordmark matches V3Shell / VendorShell.
 */
import { brand } from '../../config/brand'
import { BrandWordmark } from '../brand/BrandWordmark'

export const AUTH_TAGLINE =
  'Construction billing, lien intelligence, and cash flow.'

export function AuthBrandHeader() {
  return (
    <div
      className="auth-brand"
      data-testid="auth-brand"
      style={{
        textAlign: 'center',
        marginBottom: 18,
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 8,
        }}
      >
        <BrandWordmark nameClassName="brand-tt" />
      </div>
      <p
        className="auth-tagline"
        data-testid="auth-tagline"
        style={{
          fontSize: 12,
          color: 'var(--ink4)',
          margin: 0,
          lineHeight: 1.45,
          maxWidth: 320,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        {AUTH_TAGLINE}
      </p>
    </div>
  )
}

export function AuthFooter() {
  return (
    <p
      className="auth-footer"
      data-testid="auth-footer"
      style={{
        fontSize: 11,
        color: 'var(--ink5, var(--ink4))',
        margin: '20px 0 0',
        textAlign: 'center',
      }}
    >
      © {brand.legalEntity}
      {' · '}
      <a href="/privacy" style={{ color: 'inherit' }}>Privacy</a>
      {' · '}
      <a href="/terms" style={{ color: 'inherit' }}>Terms</a>
    </p>
  )
}
